<template>
  <header class="header-wrapper">

    <!-- Header contents -->
    <!-- <div class="banner-wrapper" v-if="!!Number(banner_opened)">
      <div class="banner">
        <div class="banner-text">
          <span>비블리오트리즈의 이용권이 월 단위 <span class="banner-text-bold">정기구독</span>으로 변경될 예정입니다.</span>
          <span>이후에는 1년 이용권 및 평생 이용권을 구입하실 수 없습니다.</span>
          <div><span class="banner-text-bold">평생이용권</span>을 99,000원에 구입할 수 있는 <span class="banner-text-bold">마지막 기회</span>를 놓치지 마세요!</div>
        </div>
        <div class="banner-btns">
          <router-link tag="span" :to="{name:'signup'}">
            <v-btn color="white" outlined><b class="banner-text">이용권 구매하기</b></v-btn>
          </router-link>
          <v-btn icon @click="close()" class="banner-close">
            <v-icon color=white>close</v-icon>
          </v-btn>
        </div>
      </div>
    </div> -->

    <div class="header-contents">

      <router-link tag="div"
        class="header-col pointer-element"
        :to="{name:'welcome'}">
        <img class="bt-logo" src="/static/android-chrome-192x192.png">
        <div class="bt-title">BiblioTrees</div>
      </router-link>

      <div class="header-col bt-nav" v-if="screen_width>1080">

        <router-link
          tag="div" class="bt-menu link-element"
          :to="{name:'plans'}">
          {{ $t('welcome.plans') }}
        </router-link>

        <router-link
          tag="div" class="bt-menu link-element"
          :to="{name:'guide'}">
          {{ $t('welcome.guide') }}
        </router-link>

        <div class="horizontal-line"></div>

        <router-link v-if="!user_name"
          tag="div" class="bt-menu link-text link-element"
          :to="{name:'signup'}">
          {{ $t('welcome.register') }}
        </router-link>

        <router-link v-if="!user_name" 
          tag="div" class="bt-menu link-element"
          :to="{name:'lab'}">
          {{ $t('welcome.login') }}
        </router-link>

        <router-link v-if="!!user_name"
          tag="div" class="bt-menu link-text link-element"
          :to="{name:'lab'}">
          {{ user_name }}'s lab
        </router-link>

        <div v-if="!!user_name"
          class="bt-menu link-element"
          @click="logout">
          {{ $t('welcome.logout') }}
        </div>

      </div>

      <div class="header-col bt-nav" v-else>
        <v-icon @click="drawer=!drawer">mdi-menu</v-icon>
      </div>

    </div>

    <!-- Drawer -->
    <div class="drawer-nav" v-prevent-parent-scroll
      :style="display_nav" v-if="drawer&&screen_width<1080">
      <div class="header-contents">
        <div>
          <router-link tag="div" v-if="screen_width<400"
            class="header-col pointer-element"
            :to="{name:'welcome'}">
            <img class="bt-logo" src="/static/android-chrome-192x192.png">
            <div class="bt-title">BiblioTrees</div>
          </router-link>
        </div>

        <div>
          <v-icon @click="drawer=false">mdi-close</v-icon>
        </div>
      </div>

      <div class="bt-nav">
        <router-link v-if="!user_name"
          tag="div" class="bt-menu link-text link-element"
          :to="{name:'signup'}">
          {{ $t('welcome.register') }}
        </router-link>

        <router-link v-if="!user_name" 
          tag="div" class="bt-menu link-element"
          :to="{name:'lab'}">
          {{ $t('welcome.login') }}
        </router-link>

        <router-link v-if="!!user_name"
          tag="div" class="bt-menu link-text link-element"
          :to="{name:'lab'}">
          {{ user_name }}'s lab
        </router-link>

        <div v-if="!!user_name"
          class="bt-menu link-element"
          @click="logout">
          {{ $t('welcome.logout') }}
        </div>
      </div>

      <div class="bt-nav">
        <router-link
          tag="div" class="bt-menu link-element"
          :to="{name:'plans'}">
          {{ $t('welcome.plans') }}
        </router-link>

        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'guide'}">
          {{ $t('welcome.guide') }}
        </router-link>

        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'whats-new'}">
          {{ $t("account_modal.what_s_new_in_bt") }}
        </router-link>

        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'notice'}">
          {{ $t('welcome.notice') }}
        </router-link>
      </div>

      <div class="bt-nav">
        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'policy'}">
          {{ $t('welcome.policy') }}
        </router-link>

        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'commercial-terms'}">
          {{ $t('welcome.commercial_terms') }}
        </router-link>

        <router-link tag="div"
          class="bt-menu link-element"
          :to="{name:'privacy'}">
          {{ $t('welcome.privacy') }}
        </router-link>
      </div>

    </div>

    <!-- Drawer mask -->
    <div @click="drawer=false" v-prevent-parent-scroll
      v-if="drawer&&screen_width<1080"
      class="drawer-nav-close drawer-nav-mask" :style="display_nav">
    </div>

  </header>
</template>

<script>
export default {

  data() {
    return {
      drawer: false,
      firstname: null,
      username: null,
      screen_width: window.innerWidth,
      banner_opened: false,
    }
  },

  created() {
    this.$store.commit('welcome/resetEmail')
    window.addEventListener("resize", this.resize)
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  computed: {
    route_full_path() {
      return this.$route.fullPath
    },

    display_nav() {
      return this.drawer ? 'display: block' : 'display: none'
    },

    user_name() {
      return !!this.firstname ? this.firstname : this.username
    },
  },

  watch: {
    route_full_path: {
      async handler(val) {
        let access_token = this.$store.getters['auth/access_token']
        if (!!access_token) {
          try {
            await this.$store.dispatch('user/getUserInfo')
          } finally {
            this.firstname = this.$store.getters['user/firstname']
            this.username = this.$store.getters['user/username']
          }
        }
        this.banner_opened = this.$cookies.get('intro_banner')
        if (this.banner_opened===null) {
          this.$cookies.set('intro_banner', 1, 60*60*24*7)
          this.banner_opened = 1
        }
        // console.log('banner', this.banner_opened)
      },
      immediate: true,
    },

    drawer: {
      handler(val) {
        this.$store.commit('welcome/setDrawer', val)
      },
      immediate: true,
    },
  },

  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout')
    },

    resize() {
      this.screen_width = window.innerWidth
      this.drawer = false
    },

    close() {
      this.$cookies.set('intro_banner', 0)
      this.banner_opened = false
    },
  },
}
</script>

<style scoped>
  .banner-wrapper {
    background-color:#e0457a;
    color: white;
    font-size: 18px;
  }

  .banner {
    max-width: 1280px;
    margin: auto;
    padding: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .banner-text {
    font-size: 1rem;
  }

  .banner-text-bold {
    font-size: 1.20rem;
    font-weight: 600;
  }

  .banner-btns {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: 10px;
  }

  .banner-close {
    margin-left: 10px;
  }

  .header-wrapper {
    position: relative;
    z-index: 1000;
    top: 0;
    width: 100%;
    background-color: rgba(255,255,255,0.7);
  }

  .header-contents {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    max-width: 1280px;
    padding: 0 24px;
    margin: auto;
  }

  .header-col {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;
  }

  .bt-logo {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    transform: translateY(1.5px);
  }

  .bt-title{
    font-family: "Bree Serif", serif;
    font-size: 16pt;
  }

  .bt-nav > .bt-menu {
    padding: 0 24px;
    font-size: 14px;
    font-family: "Montserrat", 'Spoqa Han Sans', sans-serif !important;
  }

  .drawer-nav > .bt-nav {
    font-family: "Montserrat", 'Spoqa Han Sans', sans-serif !important;
    padding: 40px 0;
    border-top: 1px #eeeeee solid;
  }

  .drawer-nav > .bt-nav > .bt-menu {
    padding-bottom: 20px;
  }

  .drawer-nav-mask {
    cursor: pointer;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7)
  }

  .horizontal-line {
    border-right: 1px solid rgb(221, 221, 221);
    height: 14px;
    margin-left: 10px;
    margin-right: 10px;
  }

  @media only screen and (max-width: 400px) {
    .drawer-nav {
      width: auto !important;
      left: 0;
    }
  }

  @media only screen and (max-width: 550px) {
    .banner {
      flex-direction: column;
    }

    .banner-btns {
      width: 100%;
    }
  }

  @media only screen and (max-width: 1080px) {
    .drawer-nav {
      position: fixed;
      width: 320px;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      padding: 0;
      overflow: scroll;
      z-index: 998;
    }

    .drawer-nav-mask {
      z-index: 997;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared_components/part/HeaderWelcome.vue